import { Component, HostListener } from '@angular/core';
import {  MatDialog,MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';

@Component({
    selector: 'app-file-upload-dialog',
    templateUrl: './file-upload-dialog.component.html',
    styleUrls: ['./file-upload-dialog.component.css'],
    standalone: false
})
export class FileUploadDialogComponent {
  fileContent: string = '';
  error: string = '';

  constructor(private dialogRef: MatDialogRef<FileUploadDialogComponent>) {}
  @HostListener('document:keydown.escape')
  onEscapePress() {
    this.dialogRef.close();
  }

  onFileSelected(event: any) {
    const file = event.target.files[0];

    if (!file) return;

    const reader = new FileReader();

    reader.onload = (e: any) => {
      this.fileContent = e.target.result;
      this.error = '';
    };

    reader.onerror = () => {
      this.error = "Cannot read file.";
    };

    reader.readAsText(file);
  }

  importFile() {
    const lines = this.fileContent.split(/\r?\n/).filter(x => x.trim() !== '');

    const results: Array<{ find: string, replace: string }> = [];

    for (const line of lines) {
      const trimmed = line.trim();

      // detect delimiter: comma, tab, semicolon, pipe
      const delimiter =
        trimmed.includes(',') ? ',' :
        trimmed.includes('\t') ? '\t' :
        trimmed.includes(';') ? ';' :
        trimmed.includes('|') ? '|' :
        null;

      if (!delimiter) {
        // NO DELIMITER → treat whole line as FIND only
        results.push({
          find: trimmed.replace(/^"|"$/g, ""),
          replace: ""
        });
        continue;
      }

      // HAS DELIMITER → split into find + replace
      const parts = trimmed.split(delimiter);

      if (parts.length < 2) {
        this.error = `Invalid row: ${line}`;
        return;
      }

      results.push({
        find: parts[0].trim().replace(/^"|"$/g, ""),
        replace: parts[1].trim().replace(/^"|"$/g, "")
      });
    }

    this.dialogRef.close(results);
  }
}

